var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoKyc24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 16,
    viewBox: "0 0 15.999 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_Kyc24x24",
    transform: "translate(15760.747 5712.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26377",
    transform: "translate(-15760.748 -5712.742)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46787",
    d: "M-16226.023-5861.8a.672.672,0,0,0-.658.741v3.541h-3.295c-.41,0-.822.165-.822.577s.412.577.822.577h3.871a.649.649,0,0,0,.658-.659v-4.117A.583.583,0,0,0-16226.023-5861.8Z",
    transform: "translate(16241.447 5872.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46790",
    d: "M-16226.023-5869.465a.672.672,0,0,1-.658-.741v-3.541h-3.295c-.41,0-.822-.165-.822-.577s.412-.577.822-.577h3.871a.649.649,0,0,1,.658.659v4.117A.583.583,0,0,1-16226.023-5869.465Z",
    transform: "translate(16241.447 5874.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46791",
    d: "M-16243.327-5869.465a.672.672,0,0,0,.658-.741v-3.541h3.294c.411,0,.823-.165.823-.577s-.412-.577-.823-.577h-3.87a.65.65,0,0,0-.659.659v4.117C-16243.986-5869.794-16243.821-5869.465-16243.327-5869.465Z",
    transform: "translate(16243.925 5874.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46792",
    d: "M-16243.327-5861.8a.672.672,0,0,1,.658.741v3.541h3.294c.411,0,.823.165.823.577s-.412.577-.823.577h-3.87a.65.65,0,0,1-.659-.659v-4.117C-16243.986-5861.471-16243.821-5861.8-16243.327-5861.8Z",
    transform: "translate(16243.925 5872.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46789",
    d: "M-16230.472-5865.917a4.6,4.6,0,0,0-4.613-4.583,4.6,4.6,0,0,0-4.614,4.583,4.6,4.6,0,0,0,4.614,4.583A4.649,4.649,0,0,0-16230.472-5865.917Zm-2.59-.4-1.943,2.09a.639.639,0,0,1-.891,0h0l-1.052-1.125a.73.73,0,0,1,0-.965c.243-.322.648-.241.971,0h0l.568.563,1.456-1.608a.645.645,0,0,1,.891-.081h0a1.12,1.12,0,0,1,0,1.125Z",
    transform: "translate(16243.178 5874.123)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoKyc24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_Kyc24x24.56bd2f2a565cdf86d9e8f075a016254f.svg";